import { forwardRef, type Ref, type SVGProps } from "react";
const IconDoubleChevronRightOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <g fillRule="evenodd" clipRule="evenodd">
      <path d="M5.979 2c.258 0 .506.106.688.296l12.593 13.02a1.02 1.02 0 0 1 0 1.422L6.666 29.76a.946.946 0 0 1-1.316-.052 1.027 1.027 0 0 1-.05-1.36l11.895-12.31L5.291 3.729A1.02 1.02 0 0 1 5 3.012c0-.27.105-.528.291-.716A.95.95 0 0 1 5.979 2" />
      <path d="M13.433 2c.258 0 .506.106.688.296l12.593 13.02c.183.188.286.444.286.711s-.103.523-.286.711L14.12 29.76a.946.946 0 0 1-1.315-.052 1.027 1.027 0 0 1-.051-1.36l11.895-12.31L12.745 3.729a1.02 1.02 0 0 1-.292-.716c0-.27.106-.528.292-.716A.95.95 0 0 1 13.433 2" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(IconDoubleChevronRightOutlineSVG);
ForwardRef.displayName = "IconDoubleChevronRightOutline";
export { ForwardRef as IconDoubleChevronRightOutline };
